"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassengerCommunicationStoryCategory = void 0;
exports.PassengerCommunicationStoryCategory = {
    CONFIRMATION_MESSAGE: 'CONFIRMATION_MESSAGE',
    APPROACH_MESSAGE: 'APPROACH_MESSAGE',
    INDAPLACE_MESSAGE: 'INDAPLACE_MESSAGE',
    TRANSPORT_MESSAGE: 'TRANSPORT_MESSAGE',
    NO_SHOW_MESSAGE: 'NO_SHOW_MESSAGE',
    ADMIN_CANCELLATION_MESSAGE: 'ADMIN_CANCELLATION_MESSAGE',
    PAYMENT_MESSAGE: 'PAYMENT_MESSAGE',
    ADD_INFO: 'ADD_INFO',
    CONFIRMATION_EMAIL: 'CONFIRMATION_EMAIL',
    CANCELLATION_EMAIL: 'CANCELLATION_EMAIL',
    TERMINATION_EMAIL: 'TERMINATION_EMAIL',
};
